import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Пачка кадров над зоной загрузки — иллюстрация, а не иконка: маска реестра одноцветна и глушит
 * opacity, поэтому штрих рисуется тут. Пропорцию держит viewBox, ширину задаёт хост классом
 * (`w-26` — размер эталона онбординга, `w-10.5` — компактная строка).
 */
@Component({
  selector: 'app-upload-illustration',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block text-c3', 'aria-hidden': 'true' },
  template: `
    <svg
      class="h-auto w-full"
      viewBox="0 0 104 88"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="14" y="10" width="60" height="46" rx="6" transform="rotate(-8 44 33)" opacity=".45" />
      <rect x="30" y="16" width="60" height="46" rx="6" transform="rotate(7 60 39)" opacity=".45" />
      <rect x="22" y="30" width="60" height="48" rx="6" class="fill-bg2" />
      <circle cx="38" cy="45" r="5" />
      <path d="M22 68l17-15 12 11 9-8 22 20" />
    </svg>
  `,
})
export class UploadIllustrationComponent {}
